import { Ticket } from './ticket.model';

export interface TicketDateParts {
  /** "NOV" */
  month: string;
  /** "5" */
  day: string;
  /** "13:00" */
  time: string;
  /** "Jueves 5 de noviembre" */
  long: string;
  isToday: boolean;
}

export interface TicketStatus {
  label: string;
  tone: 'today' | 'neutral' | 'muted';
}

const LOCALE = 'es-MX';

/** `starts_at` viene sin zona, en hora del campus: se lee tal cual, sin convertir a la del teléfono. */
export function ticketDateParts(startsAt: string, now = new Date()): TicketDateParts {
  const [year, month, day, hour, minute] = (startsAt.match(/\d+/g) ?? []).map(Number);
  const date = new Date(year, month - 1, day, hour || 0, minute || 0);
  const long = new Intl.DateTimeFormat(LOCALE, { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
  return {
    month: new Intl.DateTimeFormat(LOCALE, { month: 'short' }).format(date).replace('.', '').toUpperCase(),
    day: String(day),
    time: `${String(hour || 0).padStart(2, '0')}:${String(minute || 0).padStart(2, '0')}`,
    long: long.charAt(0).toUpperCase() + long.slice(1).replace(',', ''),
    isToday: date.toDateString() === now.toDateString(),
  };
}

/** El estado siempre va en texto: nunca sólo con color. "Sí viajó" = `status > 0` y escaneado. */
export function ticketStatus(ticket: Pick<Ticket, 'status' | 'scanned_at' | 'cancellation_reason' | 'starts_at'>, now = new Date()): TicketStatus {
  if (ticket.status === -1) {
    return { label: ticket.cancellation_reason === 'no_show' ? 'No se presentó' : 'Cancelado', tone: 'muted' };
  }
  if (ticket.status > 0 && ticket.scanned_at) return { label: 'Usado', tone: 'neutral' };
  if (ticketDateParts(ticket.starts_at, now).isToday) return { label: 'Hoy', tone: 'today' };
  return { label: 'Confirmado', tone: 'neutral' };
}
